export const API_URL  = process.env.REACT_APP_API_URL  || 'https://api.desktopcallrecorder.com';
export const LANDING_URL = process.env.REACT_APP_LANDING_SITE_URL || 'https://desktopcallrecorder.com';
export const USERAREA_URL = process.env.REACT_APP_USER_AREA_URL || 'https://subscription.desktopcallrecorder.com';

// Emergency kill-switch: when true, everyone sees the maintenance page regardless of region.
// Normal routing (stripe or maintenance) is decided server-side via
// /api/order/paymentmode; leave this false unless you need to hard-stop all checkout.
export const PAYMENTS_DISABLED = false;
